import { SelectField } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import useAddNewSelector from '@ubeya/shared-web/hooks/useAddNewSelector';
import useBranchCostCenters from '@ubeya/shared/hooks/account/useBranchCostCenters';
import React, { useContext } from 'react';
import styled, { css } from 'styled-components';

const Wrapper = styled.div.attrs(() => ({ className: 'uniform-wrapper' }))`
  ${({ $hideBorder }) =>
    $hideBorder &&
    css`
      .select {
        border: none;
        box-shadow: none;
      }
    `}
`;

const CostCentersSelectField = React.forwardRef(
  (
    { title, name = 'branchCostCenterId', hideBorder = false, hideTitle = false, onChangeValue, ...restSelectProps },
    ref
  ) => {
    const { t } = useContext(ConfigContext);

    const { branchCostCentersOptions, isLoading } = useBranchCostCenters();
    const { options: labelOptions, onChange: onChangeCostCenter } = useAddNewSelector({
      options: branchCostCentersOptions,
      addText: 'addNewLabel',
      enable: false,
      onChange: onChangeValue
    });

    return (
      <Wrapper $hideBorder={hideBorder}>
        <SelectField
          ref={ref}
          name={name}
          title={hideTitle ? '' : title ?? t('costCenter')}
          options={labelOptions || {}}
          onChange={onChangeCostCenter}
          usePortal
          isMulti={false}
          showValueAsTooltipBody
          isLoading={isLoading}
          clearable
          {...restSelectProps}
        />
      </Wrapper>
    );
  }
);

export default CostCentersSelectField;
